export const ASYNC_TASK = '/async_tasks';
export const ASYNC_TASK_SEARCH = `${ASYNC_TASK}/search`;
export const ASYNC_TASK_SESSION_TIME_TRAVEL = `${ASYNC_TASK}/sessionTimeTravel`;
